import React, { useState } from 'react';
import SearchProperty from './searchProperty/searchProperty.constants';
import FormKeyset from './formKeyset/formKeyset.constants';

const CreateKeyset = ({ onSubmit }: any) => {
  const [step, setStep] = useState({
    value: 1,
    description: 'Ingresar NID',
  });

  const handleChangeStep = (data: any) => {
    setStep(data);
  };

  return (
    <div className='container max-w-md mx-auto py-12 pb-24 p-4'>
      <div className='max-w-2xl mx-auto mb-8 text-center'>
        <span className='font-bold tracking-wider uppercase dark:text-violet-400'>
          Llaves
        </span>
        <h2 className='text-4xl font-bold lg:text-5xl'>Crear llaves</h2>
      </div>

      <div className='p-4 space-y-2 bg-blue-50 rounded-2xl darkNot:bg-gray-800 darkNot:text-gray-100'>
        <h3 className='text-base font-semibold'>
          Paso {step.value}: {step.description}
        </h3>
        <div className='flex max-w-xs space-x-3'>
          <span
            className={`w-12 h-2 rounded-sm ${
              step.value >= 1
                ? 'bg-blue-400 darkNot:bg-violet-400'
                : 'bg-gray-300 darkNot:bg-violet-400'
            }`}
          ></span>
          <span
            className={`w-12 h-2 rounded-sm ${
              step.value >= 2
                ? 'bg-blue-400 darkNot:bg-violet-400'
                : 'bg-gray-300 darkNot:bg-violet-400'
            }`}
          ></span>
        </div>
      </div>

      <SearchProperty
        onComplete={() => {
          handleChangeStep({
            value: 2,
            description: 'Personaliza tu llave',
          });
        }}
        onChangeInputValue={() => {
          handleChangeStep({
            value: 1,
            description: 'Ingresar NID',
          });
        }}
      />

      {step.value === 2 && (
        <>
          <hr className='my-9' />
          <FormKeyset onSubmit={onSubmit} />
        </>
      )}
    </div>
  );
};

export default CreateKeyset;
